// ABOUTME: Grid of data source options for users to choose their connector type.
// ABOUTME: Routes Databricks to the wizard and all others to the ComingSoon screen.

import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { SourceCard } from './SourceCard';

export interface DataSourceOption {
  name: string;
  sourceType: string;
  logoSrc: string;
}

const DATA_SOURCES: DataSourceOption[] = [
  { name: 'Databricks', sourceType: 'databricks', logoSrc: '/logos/databricks.png' },
  { name: 'Excel / CSV', sourceType: 'excel_csv', logoSrc: '/logos/excel-csv.svg' },
  { name: 'Snowflake', sourceType: 'snowflake', logoSrc: '/logos/snowflake.png' },
  { name: 'BigQuery', sourceType: 'bigquery', logoSrc: '/logos/bigquery.png' },
  { name: 'Redshift', sourceType: 'redshift', logoSrc: '/logos/redshift.png' },
  { name: 'PostgreSQL', sourceType: 'postgresql', logoSrc: '/logos/postgresql.svg' },
  { name: 'MySQL', sourceType: 'mysql', logoSrc: '/logos/mysql.svg' },
];

interface DataSourceSelectorProps {
  onSelectDatabricks: () => void;
  onSelectCsv?: () => void;
  csvUploadEnabled?: boolean;
  onSelectComingSoon: (source: DataSourceOption) => void;
  onBack?: () => void;
}

export function DataSourceSelector({
  onSelectDatabricks,
  onSelectCsv,
  csvUploadEnabled,
  onSelectComingSoon,
  onBack,
}: DataSourceSelectorProps) {
  return (
    <div className="max-w-3xl mx-auto">
      {/* Back button */}
      {onBack && (
        <div className="mb-8">
          <Button variant="ghost" size="sm" onClick={onBack} aria-label="Back">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Back
          </Button>
        </div>
      )}

      {/* Header */}
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-surface-900 mb-2">
          Connect your data
        </h2>
        <p className="text-surface-600">
          Choose your data source
        </p>
      </div>

      {/* Source Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
        {DATA_SOURCES.map((source) => (
          <SourceCard
            key={source.sourceType}
            name={source.name}
            logoSrc={source.logoSrc}
            onClick={() => {
              if (source.sourceType === 'databricks') {
                onSelectDatabricks();
              } else if (source.sourceType === 'excel_csv' && csvUploadEnabled && onSelectCsv) {
                onSelectCsv();
              } else {
                onSelectComingSoon(source);
              }
            }}
          />
        ))}
      </div>
    </div>
  );
}
